module.exports = __webpack_public_path__ + "img/index-1.b802b40f.png";